import { FixRequestStatusType, IssueEntity, IssueSourceType, IssueState } from '@/types';

export const PAYWALL_ISSUES: IssueEntity[] = [
    {
        id: 'paywall-issue-2',
        appId: '',
        title: 'Users report slow app startup after the latest update',
        state: IssueState.New,
        description:
            'Multiple 1–2★ reviews mention 5–10s cold start times since 2.13.0, with several users threatening to uninstall.',
        versions: ['2.13.0'],
        sources: [
            {
                id: 'paywall-source-1',
                type: IssueSourceType.UserReviews,
                userReviews: { aiDescription: 'Slow cold start reported across recent reviews', version: '2.13.0' },
            },
            {
                id: 'paywall-source-2',
                type: IssueSourceType.OBAA,
                healthMetrics: {
                    metricId: 'cold_start_time',
                    metricName: 'cold_start_time',
                    integrationType: 'firebase',
                    currentValue: 8.2,
                    build: '4510',
                    version: '2.13.0',
                },
            },
        ],
        assigneeUserIds: [],
        suggestedAssigneeUserIds: [],
        assigneeGroupIds: [],
        assigneeAgentIds: [],
        relatedIssueIds: [],
        relatedResolutionItemIds: [],
        createdAt: '2026-06-29T08:00:00Z',
        updatedAt: '2026-06-29T08:00:00Z',
    },
    {
        id: 'paywall-issue-3',
        appId: '',
        title: 'Beta testers: login button unresponsive on first tap',
        state: IssueState.Assigned,
        description:
            'Several TestFlight testers on build 4530 report the login button does nothing on first tap and only works after backgrounding the app.',
        versions: ['2.14.0'],
        build: { identifier: '4530' },
        sources: [
            {
                id: 'paywall-source-3',
                type: IssueSourceType.BetaFeedback,
                betaFeedback: {
                    aiDescription: 'Unresponsive login button reported by multiple beta testers',
                    version: '2.14.0',
                    build: '4530',
                },
            },
        ],
        assigneeUserIds: ['beta-user-1'],
        suggestedAssigneeUserIds: [],
        assigneeGroupIds: [],
        assigneeAgentIds: [],
        relatedIssueIds: [],
        relatedResolutionItemIds: [],
        createdAt: '2026-06-30T11:00:00Z',
        updatedAt: '2026-06-30T11:00:00Z',
    },
    {
        id: 'paywall-issue-1',
        appId: '',
        title: 'App crashes on checkout for some Android 14 devices',
        state: IssueState.FixRequested,
        description:
            'Fatal NullPointerException in CheckoutActivity when tapping "Place order" — spiking on 2.14.0 across Pixel and Samsung devices.',
        versions: ['2.14.0'],
        build: { identifier: '4521' },
        sources: [{ id: 'paywall-source-4', type: IssueSourceType.Runway }],
        fixRequest: {
            id: 'paywall-fr-1',
            createdBy: 'paywall-user-1',
            createdAt: '2026-06-28T10:00:00Z',
            formFieldsSettings: [],
            formFieldsValues: [{ fieldId: 'summary', value: 'Guard against null cart state in CheckoutActivity' }],
            status: {
                status: FixRequestStatusType.FixRequestPending,
                updatedAt: '2026-06-28T10:00:00Z',
                authorIds: [],
            },
            fixVersion: '2.14.1',
        },
        assigneeUserIds: ['paywall-user-1'],
        suggestedAssigneeUserIds: [],
        assigneeGroupIds: [],
        assigneeAgentIds: [],
        relatedIssueIds: [],
        relatedResolutionItemIds: [],
        createdAt: '2026-06-27T09:00:00Z',
        updatedAt: '2026-06-28T10:00:00Z',
    },
];
